import type { WebhookDeliveryDto } from "@dune/types";

export const WEBHOOK_STATUS_LABELS: Record<
	WebhookDeliveryDto["status"],
	string
> = {
	DELIVERED: "Livré",
	FAILED: "Erreur",
	PENDING: "En attente",
	RETRYING: "Nouvelle tentative",
};

export const getStatusBadgeVariant = (status: WebhookDeliveryDto["status"]) => {
	switch (status) {
		case "DELIVERED":
			return "success" as const;
		case "FAILED":
			return "destructive" as const;
		default:
			return "outline" as const;
	}
};

export const formatPayloadPreview = (
	payload: WebhookDeliveryDto["payload"],
) => {
	const serialized = JSON.stringify(payload);
	if (serialized.length <= 80) {
		return serialized;
	}
	return `${serialized.slice(0, 77)}…`;
};

export const formatJson = (value: unknown) => JSON.stringify(value, null, 2);

export const formatResponseLabel = (delivery: WebhookDeliveryDto) => {
	if (delivery.responseStatusCode) {
		const errorSuffix = delivery.responseError
			? ` — ${delivery.responseError}`
			: delivery.responseBody
				? ` — ${delivery.responseBody}`
				: "";
		return `${delivery.responseStatusCode}${errorSuffix}`;
	}

	if (delivery.responseError) {
		return delivery.responseError;
	}

	if (delivery.status === "PENDING" || delivery.status === "RETRYING") {
		return "En file d'attente";
	}

	return "—";
};
